import { IColumn } from "../components/normal-table/normal-table";

export const timeseriesByUnitReqs = ["modelversion_name", "nthresholds", "loss", "fp_cost", "timeframe", "column_id", "amount_id", "datetime_id", "cv_type", "cv_time_unit", "cv_with_future", "cv_train_timespan", "cv_test_timespan", "cv_n_splits"];
export const kfoldTimeseriesByNumberReqs = ["modelversion_name", "nthresholds", "loss", "fp_cost", "timeframe", "column_id", "amount_id", "datetime_id", "cv_type", "cv_n_splits"];

export const HistoryTrendsTimeframeOptions = [
  { name: "Day", id: "day" },
  { name: "Week", id: "week" },
  { name: "Month", id: "month" },
  { name: "Year", id: "year" },
];

export const historyTrendsAdittionalColums: IColumn[] = [
  {
    key: "timeframe",
    displayName: "Timeframe",
    dataType: {
      type: "enumeration",
      values: HistoryTrendsTimeframeOptions,
    },
    extraClass: "half"
  },
];

export const modelKeys = [
  { name: "Technical variable name", id: "technical_variable_name" },
  { name: "Technical variable defintion", id: "technical_variable_definition" },
  { name: "Weight", id: "weight" },
  { name: "Analyst description", id: "analyst_description"}
];

export const modelCols = [
  "technical_variable_definition",
  "technical_variable_name",
  "weight",
  "analyst_description"
];

export const sourceDataKeys = [
  { name: "Input field name", id: "input_field_name" },
  { name: "Field name", id: "field_name" },
  { name: "Field type", id: "field_type" },
  { name: "SGA data label", id: "SGA_data_label" },
  { name: "Empty field count", id: "empty_field_count" },
  { name: "NaN count", id: "nan_count" },
  { name: "Null count", id: "null_count" },
  { name: "Unique value count", id: "unique_value_count" },
];

export const crossValidationKeys = [
  { name: "Metric", id: "metric" },
  { name: "Median", id: "median" },
  { name: "Standard deviation", id: "standard_deviation" },
];

export const widgetOptions = [
  { name: "Table", id: "table" },
  { name: "Chart", id: "chart" },
];

export const reportWidgetSources = [
  { name: "Threshold table", id: "report_data" },
  { name: "Model", id: "model" },
  { name: "Source Data", id: "source_data" },
  { name: "History trend", id: "history" },
  { name: "Model configuration", id: "model_configuration" }
];

export const pairedTableslayoutOptions= [
  { name: "1/2", id: "1_2"},
  { name: "2/3", id: "2_3"},
  { name: "None", id: "none"},
];

export const pairedTableslayoutPositioningOptions= [
  { name: "Horizontal", id: "horizontal"},
  { name: "Vertical", id: "vertical"}
];

export const recordTypeOptions= [
  { name: "All", id: "all"}, 
  { name: "AlertCase", id: "alertcase"}, 
  { name: "Event", id: "event"}, 
  { name: "Entity", id: "entity"},
  { name: "Specific", id: "specific"},
  { name: "Link", id: "link"},
];

export const textWidgetOptionsReport = [
  { name: "Header", id: "header" },
  { name: "Text", id: "text" }
];

export const textWidgetOptionsReportPDF = [
  { name: "Header", id: "header" },
  { name: "Subheader", id: "subheader" },
  { name: "Text", id: "text" }
];

export const allUniqueManagementModelDataColsKeys:any = { // eslint-disable-line
  name: "Name",
  distinct_values: "Unique value count",
  null_values: "Null Count",
  record_field_name: "Record field name",
  number_of_inserts: "Number of inserts",
  number_of_rows: "Number of rows",
  number_of_updates: "Number of updates",
  record_name: "Record name",
  record_type: "Record type",
  status: "Status",
  uploaded_time: "Uploaded time",
  empty_values: "Empty values Count"
};

export const allUniqueManagementModelDataOverallColsKeys:any = { // eslint-disable-line
  name: "Name",
  distinct_values: "Unique value count",
  null_values: "Null Count",
  record_field_name: "Record field name",
  number_of_inserts: "Number of inserts",
  number_of_rows: "Number of rows",
  number_of_updates: "Number of updates",
  record_name: "Record name",
  record_type: "Record type",
  status: "Status",
  uploaded_time: "Updated time",
  empty_values: "Empty values Count"
};

export const modelManagementModelDataRecordCols:IColumn[] = [
  {
    key: "record_field_name",
    displayName: "Record field name",
    dataType: {
      type: "text",
    }
  },
  {
    key: "distinct_values",
    displayName: "Unique value count",
    dataType: {
      type: "text",
    }
  },
  {
    key: "null_values",
    displayName: "Null Count",
    dataType: {
      type: "text",
    }
  },
  {
    key: "empty_values",
    displayName: "Empty values Count",
    dataType: {
      type: "text",
    }
  }
];
   
export const modelManagementModelDataOverallCols:IColumn[] = [
  {
    key: "name",
    displayName: "Name",
    dataType: {
      type: "text",
    }
  },
  {
    key: "record_type",
    displayName: "Record type",
    dataType: {
      type: "text",
    },
  },
  {
    key: "number_of_rows",
    displayName: "Number of rows",
    dataType: {
      type: "text",
    },
  },
  {
    key: "uploaded_time",
    displayName: "Updated time",
    dataType: {
      type: "text",
    },
  }
];

export const modelManagementModelDataImportCols:IColumn[] = [
  {
    key: "record_name",
    displayName: "Record name",
    dataType: {
      type: "text",
    },
  },
  {
    key: "record_type",
    displayName: "Record type",
    dataType: {
      type: "text",
    },
  },
  {
    key: "number_of_inserts",
    displayName: "Number of inserts",
    dataType: {
      type: "text",
    }
  },
  {
    key: "number_of_rows",
    displayName: "Number of rows",
    dataType: {
      type: "text",
    },
  },
  {
    key: "number_of_updates",
    displayName: "Number of updates",
    dataType: {
      type: "text",
    },
  },
  {
    key: "status",
    displayName: "Status",
    dataType: {
      type: "text",
    },
  },
  {
    key: "uploaded_time",
    displayName: "Uploaded time",
    dataType: {
      type: "text",
    },
  },
  {
    key: "error_details",
    displayName: "Additional info",
    dataType: {
      type: "text",
    },
  }
];

export const inputWidgetOptions = [
  { name: "Text", id: "text" },
  { name: "Float", id: "float" },
  { name: "Boolean", id: "boolean" },
  { name: "DateTime", id: "datetime" },
  { name: "Integer", id: "integer" },
];

export const textWidgetOptions = [
  { name: "Chapter", id: "chapter" },
  { name: "Header", id: "header" },
  { name: "Text", id: "text" }
];

export const widgetType = [
  { name: "Custom widget", id: "Custom widget" },
  { name: "Text", id: "Text" },
  { name: "Input", id: "Input" },
  { name: "Header", id: "Header" },
];

export const widgetTypeMoldelManagement = [
  { name: "Custom widget", id: "Custom widget" },
  { name: "Text", id: "Text" },
  { name: "Header", id: "Header" },
];

export const fieldtypeOptions = [
  { name: "Text", id: "text" },
  { name: "Float", id: "float" },
  { name: "Boolean", id: "boolean" },
  { name: "DateTime", id: "datetime" },
  { name: "Integer", id: "integer" },
];

export const eventTypeOptions = [
  { name: "Text", id: "text" },
  { name: "Float", id: "float" },
  { name: "Boolean", id: "boolean" },
  { name: "DateTime", id: "datetime" },
];

export const modelTypeOptions = [
  { name: "Fraud", id: "fraud" },
  { name: "AML", id: "aml" },
];

export const modelConfigOptimizationOptions = [
  { name: "Amount", id: "amount" },
  { name: "Class Balancing", id: "class_balancing" },
  { name: "Combined", id: "combined" },
];

export const timeframeOptions = [
  { name: "Day", id: "day" },
  { name: "Week", id: "week" },
  { name: "Month", id: "month" },
  { name: "Year", id: "year" },
];

export const ambiguousLabelOptions = [
  { name: "Positive", id: "positive" },
  { name: "Negative", id: "negative" }
];

export const crossValidationType = [
  { name: "Random Kfold", id: "kfold" },
  // { name: "Timeseries by time unit", id: "timeseries_by_time_unit" },
  { name: "Timeseries by number of transactions", id: "timeseries_by_n_transactions" },
];

export const activeOptions = [
  { name: "No", id: "false" },
  { name: "Yes", id: "true" },
];

export const modelConfigThreshholdOptions = [
  { name: "10", id: "11" },
  { name: "100", id: "101" },
  { name: "1000", id: "1001" },
];

export const logLeveloptions = [
  { name: "off", id: "off" },
  { name: "fatal", id: "fatal" },
  { name: "error", id: "error" },
  { name: "warn", id: "warn" },
  { name: "info", id: "info" },
  { name: "debug", id: "debug" },
  { name: "trace", id: "trace" },
  { name: "all", id: "all" },
];

export const dataLabels = [
  { name: "Entity", id: "entity" },
  { name: "Amount", id: "amount" },
  { name: "Amount Direction", id: "amount_direction" },
  { name: "Category", id: "category" },
  { name: "Datetime", id: "datetime" },
  { name: "Suspicious", id: "suspicious" },
  { name: "AlertCase", id: "alertcase" },
];

export const outputTypeOptions = [
  { name: "SQL", id: "sql" },
];

export const scoreLocationOptions = [
  { name: "Same table", id: "same_table" },
  { name: "Dedicated table", id: "dedicated_table" },
];

export const aggregateStoreTypeOptions = [
  { name: "CSV", id: "csv" },
  { name: "Table", id: "table" },
];

export const databaseTypes = [
  { name: "CSV", id: "csv" },
  { name: "Database", id: "db" },
];

export const processTypeStageActionTypesOptions = [
  { name: "Mandatory", id: "mandatory" },
  { name: "Recommended", id: "recommended"},
  { name: "Optional", id: "optional"},
];

export const processTypeStageToPerformOptions = [
  { name: "Document", id: "document" },
  { name: "Checkmark", id: "checkmark"},
  { name: "Note", id: "note"},
];

export const defaultSettingsKeys = {
  csv_separator: ",", 
  datetime_format: "%Y-%m-%d %H:%M:%S",
  alertcase: "",
  alertcase_id: "",
  alertcase_field_id: "",
  alertcase_field: "",
  alertcase_label_field_id: "",
  alertcase_label_field: "",
  alertcase_list_id: "",
  alertcase_list: "",
  label_list: "",
  label_list_id: "",
  enable_scoring: "false",
  primary_datetime_column_id: "",
  primary_datetime_column: "",
  process_type_column_id: "",
  process_type_column: "",
};
